module.exports = __webpack_public_path__ + "img/copper.94598502.webp";